export const TREND_MONTHS = 6;

export function getMonthBuckets(count = TREND_MONTHS) {
  const buckets = [];
  for (let i = count - 1; i >= 0; i -= 1) {
    const d = new Date();
    d.setDate(1);
    d.setHours(0, 0, 0, 0);
    d.setMonth(d.getMonth() - i);
    buckets.push({
      key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      label: d.toLocaleDateString('en-GB', { month: 'short', year: '2-digit' }),
    });
  }
  return buckets;
}

export function getTrendStartDate(months = TREND_MONTHS) {
  const d = new Date();
  d.setDate(1);
  d.setHours(0, 0, 0, 0);
  d.setMonth(d.getMonth() - (months - 1));
  return d;
}

export function countByMonth(items, dateField = 'created_at', buckets) {
  const map = Object.fromEntries(buckets.map((b) => [b.key, 0]));
  (items || []).forEach((item) => {
    const raw = item?.[dateField];
    if (!raw) return;
    const d = new Date(raw);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    if (map[key] !== undefined) map[key] += 1;
  });
  return map;
}

export function buildTrendSeries(buckets, seriesList) {
  return buckets.map((bucket) => {
    const row = { month: bucket.label };
    seriesList.forEach(({ key, counts }) => {
      row[key] = counts[bucket.key] || 0;
    });
    return row;
  });
}

export function countByField(items, field, labelMap = {}) {
  const map = {};
  (items || []).forEach((item) => {
    const val = item?.[field] || 'unknown';
    map[val] = (map[val] || 0) + 1;
  });
  return Object.entries(map)
    .map(([name, value]) => ({
      name: labelMap[name] || formatLabel(name),
      value,
    }))
    .sort((a, b) => b.value - a.value);
}

export function formatLabel(value) {
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function calcPeriodChange(current, previous) {
  if (previous === 0) return current > 0 ? 100 : 0;
  return Math.round(((current - previous) / previous) * 100);
}

export function buildMetricCard({ total, currentPeriod, previousPeriod, trendLabel = 'vs prior 30 days' }) {
  const change = calcPeriodChange(currentPeriod, previousPeriod);
  let changeType = 'neutral';
  if (change > 0) changeType = 'positive';
  if (change < 0) changeType = 'negative';

  return {
    value: total,
    change: `${change >= 0 ? '+' : ''}${change}%`,
    changeType,
    trend: trendLabel,
    currentPeriod,
    previousPeriod,
  };
}
